import { ApiService } from '../../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { AutomaticReceiptSettingsDto } from './automatic-receipt-settings.dto';

@Injectable({
  providedIn: 'root',
})
export class ReceiptService {
  constructor(private _apiService: ApiService) {}

  public GetAutomaticReciptSettings(): Promise<AutomaticReceiptSettingsDto> {
    return this._apiService.get('Revenue/AutomaticReceiptSettings');
  }

  public SendReceipt(invoiceNum: number): Promise<void> {
    return this._apiService.post('Revenue/SendAutomaticReceipt', { InvoiceNumber: invoiceNum });
  }
}
